import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { MenuItems, PermissionValue, UserHttpService, UserType } from "../public-api";

@Injectable({
    providedIn: "root"
})
export class NavbarService {
    public MenuRouteLinks$: BehaviorSubject<MenuItems[]> = new BehaviorSubject<MenuItems[]>([]);
    public MenuRouteLinks2$: BehaviorSubject<MenuItems[]> = new BehaviorSubject<MenuItems[]>([]);
    private MenuRouteLinks!: MenuItems[];
    private MenuRouteLinks2!: MenuItems[];

    constructor(
        private userService: UserHttpService
    ) {

    }

    getNavLinks() {
        const userData = this.userService.getUserInfo;
        if (userData && userData.user_type && userData.user_type == UserType.USER) {
            let menu1 = [

                {
                    name: "Manage Clients",
                    path: "/user/clients/manage-clients",
                    iconurl: "manage_clients",
                    viewCondition: userData && userData.can_view == true &&
                        (
                            (userData.can_create == false && userData.can_approve == true && userData.can_support == true) ||
                            (userData.can_create == true && userData.can_approve == false && userData.can_support == true) ||
                            (userData.can_create == false && userData.can_approve == true && userData.can_support == false) ||
                            (userData.can_create == false && userData.can_approve == false && userData.can_support == true) ||
                            (userData.can_create == false && userData.can_approve == false && userData.can_support == false) ||
                            (userData.can_create == false && userData.can_approve == false && userData.can_support == false)
                        )
                },
                {
                    name: "Manage Clients",
                    path: "/user/clients",
                    iconurl: "manage_clients",
                    viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true,
                    // children: [
                    //     {
                    //         name: "Manage Clients",
                    //         path: "/user/clients/manage-clients",
                    //         viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true
                    //     },
                    //     {
                    //         name: "Manage Activities",
                    //         path: "/user/clients/manage-activities",
                    //         viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true
                    //     },
                    //     {
                    //         name: "Manage Campaign",
                    //         path: "/user/clients/manage-campaign",
                    //         viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true
                    //     },
                    //     {
                    //         name: "Manage Leads",
                    //         path: "/user/clients/manage-leads",
                    //         viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true
                    //     },
                    //     {
                    //         name: "Manage Budgets",
                    //         path: "/user/clients/manage-budgets",
                    //         viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true
                    //     },
                    // ],
                },
                {
                    name: "Manage Teams",
                    path: "/user/team",
                    iconurl: "manage_group",
                    viewCondition: userData && userData.can_view == true && userData.can_create == false,
                    children: [
                        {
                            name: "Manage Team",
                            path: "/user/team",
                            viewCondition: userData && userData.can_view == true && userData.can_create == false,
                        },
                        {
                            name: "Manage Group",
                            path: "/user/group",
                            viewCondition: userData && userData.can_view == true && userData.can_create == false,
                        },
                    ],
                },
                {
                    name: "Manage Teams",
                    path: "/user/manage-teams",
                    iconurl: "manage_group",
                    viewCondition: userData && userData.can_view == true && userData.can_create == true,
                    children: [
                        {
                            name: "Manage Team",
                            path: "/user/manage-teams/team",
                            viewCondition: userData && userData.can_view == true && userData && userData.can_create == true
                        },
                        {
                            name: "Manage Roles",
                            path: "/user/manage-teams/roles",
                            viewCondition: userData && userData.can_view == true && userData && userData.can_create == true
                        },
                        {
                            name: "Manage Groups",
                            path: "/user/manage-teams/group",
                            iconurl: "manage_group",
                            viewCondition: userData && userData.can_view == true && userData && userData.can_create == true
                        },
                    ],
                },
                {
                    name: "Manage Projects",
                    path: "/user/projects",
                    iconurl: "manage-project",
                    viewCondition: userData && userData.can_view == true,
                    children: [
                        {
                            name: "Projects",
                            path: "/user/projects",
                            viewCondition: userData && userData.can_view == true,
                        },
                        {
                            name: "Project Activities",
                            path: "/user/project-activities",
                            viewCondition: userData && userData.can_view == true && userData && userData.can_create == true
                        },
                        {
                            name: "Project Reports",
                            path: "/user/project-reports",
                            viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true,
                        },
                        {
                            name: "Quality Assurance",
                            path: "/user/quality-assurance",
                            viewCondition: userData && userData.can_view == true,
                        },
                        {
                            name: "QA Audit Report",
                            path: "/user/manage-quality-reports",
                            viewCondition: userData && userData.can_view == true,
                        },
                        {
                            name: "QA Panel",
                            path: "/user/quality-assurance/manage-qa-panel",
                            viewCondition: userData && userData.can_view == true && userData && userData.can_create == true
                        }
                    ]
                },
                {
                    name: "Manage Tasks",
                    path: "/user/tasks",
                    iconurl: "manage-task",
                    viewCondition: userData && userData.can_view == true,
                    children: [
                        {
                            name: "My Tasks",
                            path: "/user/tasks",
                            viewCondition: userData && userData.can_view == true
                        },
                        {
                            name: "My Timesheet",
                            path: "/user/timesheet",
                            viewCondition: userData && userData.can_view == true
                        },
                        {
                            name: "Timesheet Overview",
                            path: "/user/timesheet-overview",
                            viewCondition: userData && userData.can_view == true &&
                                userData.usr_role_track_id !== UserType.STAFF &&
                                userData.usr_role_track_id !== UserType.PROJECT_MANAGERS
                        },
                    ],
                },
                {
                    name: 'Manage Resources',
                    path: "/user/manage-resources",
                    iconurl: 'manage-resources',
                    viewCondition: userData && userData.can_view == true,
                },
                {
                    name: 'Cost Management',
                    path: "/user/cost-management",
                    iconurl: 'cost-management',
                    viewCondition: userData && userData.usr_role_track_id == '6',
                },
                {
                    name: 'Manage Attendance',
                    path: "/user/attendance",
                    iconurl: 'manage_group',
                    viewCondition: userData && userData.can_view == true,
                },
                {
                    name: "Reports",
                    path: "/user/reports",
                    iconurl: "reports",
                    viewCondition: userData && userData.can_view == true,
                },
                {
                    name: "Manage Documents",
                    path: "/user/documents",
                    iconurl: "manage_documents",
                    viewCondition: userData && userData.can_view == true
                },
                {
                    name: "Manage Leaves",
                    path: "/user/leaves",
                    iconurl: "manage-leaves",
                    viewCondition: userData && userData.can_view == true && (userData.can_create == true || userData.can_approve == true),
                    children: [
                        {
                            name: "My Leaves",
                            path: "/user/leaves/my",
                            viewCondition: userData && userData.can_view == true && (userData.can_create == true || userData.can_approve == true)
                        },
                        {
                            name: "Leave Overview",
                            path: "/user/leaves/overview",
                            viewCondition: userData && userData.can_view == true && userData.can_approve == true
                        },
                        {
                            name: "Leave Requests",
                            path: "/user/leaves/requests",
                            viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true
                        },
                        {
                            name: "My WFH",
                            path: "/user/wfh/my",
                            viewCondition: userData && userData.can_view == true && (userData.can_create == true || userData.can_approve == true)
                        },
                        {
                            name: "WFH Requests",
                            path: "/user/wfh/requests",
                            viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true
                        },
                        {
                            name: "Public Holidays List",
                            path: "/user/leaves/public-holidays",
                            viewCondition: userData && userData.can_view == true && userData.can_approve == true
                        },
                    ],
                },
                // {
                //     name: "Manage Meetings",
                //     path: "/user/meeting",
                //     iconurl: "manage_meeting",
                //     viewCondition: userData && userData.can_view == true
                // },

                // {
                //     name: "Manage WFH",
                //     path: "/user/wfh",
                //     iconurl: "manage-leaves",
                //     viewCondition: userData && userData.can_view == true && (userData.can_create == true || userData.can_approve == true),
                //     children: [
                //     {
                //         name: "My WFH",
                //         path: "/user/wfh/my",
                //         viewCondition: userData && userData.can_view == true && (userData.can_create == true || userData.can_approve == true)
                //     },  
                //     {
                //         name: "WFH Requests",
                //         path: "/user/wfh/requests",
                //         viewCondition: userData && userData.can_view == true && userData.can_approve == true
                //     },
                //     ],
                // },
                // {
                //     name: "Manage WFH",
                //     path: "/user/wfh",
                //     iconurl: "manage-leaves",
                //     viewCondition: userData && userData.can_view == true && (userData.can_create == false && userData.can_approve == false)
                // },
                {
                    name: "Manage Leaves",
                    path: "/user/leaves",
                    iconurl: "manage-leaves",
                    viewCondition: userData && userData.can_view == true && (userData.can_create == false && userData.can_approve == false)
                },

                // {
                //     name: "Manage Appraisals",
                //     path: "/user/appraisals",
                //     iconurl: "Appraisal",
                //     viewCondition: userData && userData.can_view == true && userData.can_support == true && (userData.can_create == true || userData.can_approve == true),
                //     children: [
                //         {
                //             name: "My Appraisals",
                //             path: "/user/appraisals/my",
                //             viewCondition: userData && userData.can_view == true && userData.can_support == true && (userData.can_create == true || userData.can_approve == true)
                //         },
                //         {
                //             name: "Appraisals Request",
                //             path: "/user/appraisals/requests",
                //             viewCondition: userData && userData.can_view == true && userData.can_support == true && (userData.can_create == true || userData.can_approve == false)
                //         },
                //     ],
                // },
                // {
                //     name: "Appraisals",
                //     path: "/user/appraisals",
                //     iconurl: "Appraisal",
                //     viewCondition: userData && userData.can_view == true && userData.can_create == false && (userData.can_approve == false || userData.can_support == true)
                // },
                // {
                //     name: "Manage Expenses",
                //     path: "/user/manage-expenses",
                //     iconurl: "manage_expenses",
                //     viewCondition: userData && userData.can_view == true
                // },
                // {
                //     name: "Manage Events",
                //     path: "/user/events/add",
                //     iconurl: "add_event",
                //     viewCondition: userData && userData.can_view == true && userData.can_create == true,
                //     children: [
                //         {
                //             name: "Add Event",
                //             path: "/user/events/add",
                //             iconurl: "add_event",
                //             viewCondition: userData && userData.can_view == true && userData.can_create == true
                //         },
                //         {
                //             name: "View Events",
                //             path: "/user/events/view",
                //             iconurl: "view_event",
                //             viewCondition: userData && userData.can_view == true
                //         },
                //     ],
                // },


                // {
                //     name: "Manage Vendors",
                //     path: "/user/manage-vendors",
                //     iconurl: "manage_vendor",
                //     viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true
                // },



                // {
                //     name: "Training",
                //     path: "/user/training",
                //     iconurl: "training",
                //     viewCondition: userData && userData.can_view == true
                // },
                // {
                //     name: "Reports",
                //     path: "/user/reports",
                //     iconurl: "reports",
                //     viewCondition: userData && userData.can_view == true
                // },
                // {
                //     name: "Manage CRM",
                //     path: "/user/crm/manage-activities",
                //     iconurl: "manage_crm",
                //     viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true,
                //     children: [
                //         {
                //             name: "Manage Activities",
                //             path: "/user/crm/manage-activities",
                //             viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true
                //         },
                //         {
                //             name: "Manage Campaign",
                //             path: "/user/crm/manage-campaign",
                //             viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true
                //         },
                //         {
                //             name: "Manage Leads",
                //             path: "/user/crm/manage-leads",
                //             viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true
                //         },
                //         {
                //             name: "Manage Budgets",
                //             path: "/user/crm/manage-budgets",
                //             viewCondition: userData && userData.can_view == true && userData.can_create == true && userData.can_approve == true
                //         },
                //     ],
                // },
                // {
                //     name: "Knowledge base",
                //     path: "/user/knowledge-base",
                //     iconurl: "knowledge-base",
                //     viewCondition: userData && userData.can_view == true
                // },
                // {
                //     name: "Resources",
                //     path: "/user/resources",
                //     iconurl: "resources2",
                //     viewCondition: userData && userData.can_view == true
                // },
                {
                    name: "Support",
                    path: "/user/support",
                    iconurl: "support",
                    viewCondition: userData && userData.can_view == true
                },
                {
                    name: "Company Forum",
                    path: "/user/company-forum",
                    iconurl: "companyforum",
                    viewCondition: userData && userData.can_view == true
                },
            ];

            let menu2 = [
                // {
                //     name: "Add Event",
                //     path: "/user/events/add",
                //     iconurl: "add_event",
                //     viewCondition: userData && userData.can_view == true && userData.can_create == true
                // },
                // {
                //     name: "View Events",
                //     path: "/user/events/view",
                //     iconurl: "view_event",
                //     viewCondition: userData && userData.can_view == true
                // },
                // {
                //     name: "Company Forum",
                //     path: "/user/company-forum",
                //     iconurl: "companyforum",
                //     viewCondition: userData && userData.can_view == true
                // },
            ];

            this.MenuRouteLinks$.next(menu1 && menu1.length > 0 ? menu1 : []);
            //this.MenuRouteLinks2$.next(menu2 && menu2.length > 0 ? menu2 : []);
        } else if (userData && userData.user_id && userData.user_type == UserType.VENDOR) {
            let menu1 = [
                {
                    name: "Manage Orders",
                    path: "/user/manage-orders",
                    iconurl: "my_orders",
                    viewCondition: userData && userData.can_view == false && userData.can_approve == false && userData.can_support == false && userData.can_create == false
                },
                {
                    name: "Reports",
                    path: "/user/vendor-reports",
                    iconurl: "reports",
                    viewCondition: userData && userData.can_view == false && userData.can_approve == false && userData.can_support == false && userData.can_create == false
                },
                {
                    name: "Reviews",
                    path: "/user/my-reviews",
                    iconurl: "reviews",
                    viewCondition: userData && userData.can_view == false && userData.can_approve == false && userData.can_support == false && userData.can_create == false
                },
                {
                    name: "Support",
                    path: "/user/support",
                    iconurl: "support",
                    viewCondition: userData && userData.can_view == false && userData.can_approve == false && userData.can_support == false && userData.can_create == false
                },
            ]
            this.MenuRouteLinks$.next(menu1 && menu1.length > 0 ? menu1 : []);
            this.MenuRouteLinks2$.next([]);
        }
    }
}